import React, { useState } from "react";
import { getOptimizedImagePath } from "../utils/imageOptimization";

interface ImageWithSkeletonProps {
  src: string;
  alt: string;
  className?: string;
  rounded?: boolean;
}

export const ImageWithSkeleton = ({
  src,
  alt,
  className = "",
  rounded = false,
}: ImageWithSkeletonProps) => {
  const [imageLoading, setImageLoading] = useState(true);
  const [webpFailed, setWebpFailed] = useState(false);
  
  const { webp, fallback } = getOptimizedImagePath(src);
  const imageSrc = webpFailed || webp === fallback ? fallback : webp;

  return (
    <>
      {imageLoading && (
        <div className={`absolute inset-0 skeleton ${rounded ? 'rounded-full' : ''}`} />
      )}
      <picture className="block">
        {webp !== fallback && !webpFailed && (
          <source srcSet={webp} type="image/webp" />
        )}
        <img
          src={imageSrc}
          alt={alt}
          className={`${className} ${imageLoading ? 'opacity-0' : 'opacity-100'} transition-opacity duration-300`}
          onLoad={() => setImageLoading(false)}
          onError={(e) => {
            // If WebP fails to load, fallback to PNG
            if (!webpFailed && webp !== fallback) {
              setWebpFailed(true);
              // Force reload with fallback
              const img = e.currentTarget;
              img.src = fallback;
            }
          }}
        />
      </picture>
    </>
  );
};

